export const MINI_PROGRAM_FLAG = 'miniprogram'

export const MP_TYPES = {
  qq: 'mp_qq',
  weixin: 'mp_weixin',
  alipay: 'mp_alipay',
  baidu: 'mp_baidu',
  toutiao: 'mp_toutiao',
}

export function getMpType(userAgent = '', win) {
  const ua = (userAgent || window.navigator.userAgent).toLowerCase()

  win = win || window // eslint-disable-line no-param-reassign

  // 百度小程序
  if (ua.indexOf('swan-baiduboxapp') > -1) {
    return MP_TYPES.baidu
  }

  // 头条小程序
  if (ua.indexOf('toutiaomicroapp') > -1) {
    return MP_TYPES.toutiao
  }

  // 腾讯系小程序
  if (win.__wxjs_environment === MINI_PROGRAM_FLAG || ua.indexOf('miniprogram') > -1) { // eslint-disable-line
    // qq 小程序
    if (ua.indexOf('qq') > -1) {
      return MP_TYPES.qq
    }
    // 微信小程序
    return MP_TYPES.weixin
  }
  return false
}

export function getMiniprogramType(userAgent, win) {
  if (!process.env.BROWSER) {
    return false
  }
  return getMpType(userAgent, win)
}

export function isMiniprogram(win) {
  if (!process.env.BROWSER) {
    return false
  }
  return (getMpType('', win) === MP_TYPES.weixin)
}
